import {currencyStringToValue, roundTo, valueToCurrency} from "./helperFunction";

export default function processCustomerPriceCalculation(price, currencyOptions, generalOptions, elementGroup, includingFees) {
    let result;

    if (includingFees === true) {
        result = roundTo(price, currencyOptions, generalOptions);
    } else {
        let presaleFee = currencyStringToValue(elementGroup.presaleFee.textContent, currencyOptions, generalOptions) || 0;
        let ticketFee = currencyStringToValue(elementGroup.ticketFee.textContent, currencyOptions, generalOptions) || 0;
        result = roundTo( price + presaleFee + ticketFee, currencyOptions, generalOptions);
    }

    elementGroup.customerPrice.textContent = valueToCurrency(result, currencyOptions);
}
